"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
import { motion } from "motion/react";
function formatGwei(gweiString) {
    const gwei = parseFloat(gweiString);
    if (gwei < 0.001)
        return "<0.001";
    if (gwei < 1)
        return gwei.toFixed(3);
    if (gwei < 10)
        return gwei.toFixed(2);
    return gwei.toFixed(1);
}
export function GasIndicator({ gasPrice, className }) {
    // Only show when gas is high or spike
    if (!["high", "spike"].includes(gasPrice.level)) {
        return null;
    }
    return (_jsxs(motion.div, { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.2 }, className: cn("flex flex-col gap-1 rounded-lg bg-orange-500/10 px-3 py-2", className), children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("span", { className: "text-xs font-medium text-orange-500", children: "Gas is high - transaction may fail or cost more" }), _jsxs("span", { className: "text-xs font-medium text-orange-500", children: [formatGwei(gasPrice.gasPriceGwei), " Gwei"] })] }), _jsx("span", { className: "text-as-secondary text-xs", children: "Consider swapping later for better rates" })] }));
}
